<div class="editTicketTitle">
  <p class="Tickettitle">{{'common.text_account_supporttickets_updateTicket_addMessage'|cxTranslate}}</p>
  <button class="dialog_close_btn" mat-dialog-close>
    <img src="/icons/close-kb.svg" alt="" class="" width="20" />
  </button>
</div>
<mat-dialog-content class="editTicketcontent">
  <form [formGroup]="newForm">
    <div class="fs_20">{{'common.text_account_supporttickets_createTicket_message'|cxTranslate}}</div>
    <div>
      <textarea formControlName="message" cols="70" rows="10"></textarea>
    </div>
    <div class="fs_20">
      {{'common.text_headline_status'|cxTranslate}}
    </div>
    <div class="select-box">
      <select formControlName="status">
        <option value="OPEN" selected>Open (current status)</option>
        <option value="COMPLETE">Complete</option>
      </select>
    </div>
  </form>
  <div class="fs_20">{{'common.text_account_supporttickets_createTicket_selectFile'|cxTranslate}}</div>
  <div class="file_upload__wrapper btn">
    <span class="file_upload__wrapper"> Choose file</span> <input #file (input)="fileSelector(file)" type="file"
    class="chooseInput" accept=".pdf, .txt, .png, .jpg, .jpeg, .gif, .doc, .docx, .html, .htm, .zip"
    data-max-upload-size="10485760" multiple />
  </div>@if (fileName ) {
  <span>{{fileName}}</span>
} @else {
  <span> &nbsp;No File Chosen</span>
}
<div class="buttonContainer">
  <button class="btn btn_blue">{{'common.text_account_replenishment_actions'|cxTranslate}}</button>
  <button class="btn btn-primary" (click)="uploadOnApi()"
  [disabled]="formControl.message.invalid">{{'common.mobile_checkout_multi_button_submit'|cxTranslate}}</button>
</div>
</mat-dialog-content>